import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken} from '../../storage'
import Select from 'react-select'
import 'react-select/dist/react-select.css';

export default class StateSelect extends React.Component {

  constructor(props){
    super(props)
    this.getStates = this.getStates.bind(this)
    this.handleChange  = this.handleChange.bind(this)
    this.state = {}
  }

  handleChange(option) {
    this.props.handleChange(option)
  }


  getStates(input) {

    if (!input) {
      return axios({
          url: '/get_states/',
          method: 'get',
          baseURL: API_BASE_URL,
          headers: {
            common: {
              'Authorization': 'Token ' + getToken()
            }
          }
        }).then((response)=> {
              return {options: response.data.states}
        }).catch((err)=> {
          console.log(err);
          return Promise.resolve({ options: [] });
        })
    }
    return   axios({
        url: '/get_states/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {

            return {options: response.data.states}
      }).catch((err)=> {
        console.log(err);
        return Promise.resolve({ options: [] });
      })

  }

  render() {

    const name = this.props.name

    let inputValue
    if(typeof this.props.value !== "undefined") {
      inputValue = this.props.value
    }


    return <Select.Async name={name} loadOptions={this.getStates} value={inputValue} valueKey="state_code" labelKey="state_name" onChange={this.handleChange} />

  }
}



// WEBPACK FOOTER //
// ./src/components/client/stateselect.js